export default {
  ACCOUNTS: {
    REQUEST: 'ACCOUNTS.REQUEST',
    SUCCESS: 'ACCOUNTS.SUCCESS',
    FAILURE: 'ACCOUNTS.FAILURE',
    RESET: 'ACCOUNTS.RESET',
    ALL: {
      REQUEST: 'ACCOUNTS.ALL.REQUEST',
      SUCCESS: 'ACCOUNTS.ALL.SUCCESS',
      FAILURE: 'ACCOUNTS.ALL.FAILURE',
      RESET: 'ACCOUNTS.ALL.RESET',
    },
    DOWNLOAD: {
      REQUEST: 'ACCOUNTS.DOWNLOAD.REQUEST',
      SUCCESS: 'ACCOUNTS.DOWNLOAD.SUCCESS',
      FAILURE: 'ACCOUNTS.DOWNLOAD.FAILURE',
    },
    HIERARCHY: {
      REQUEST: 'ACCOUNTS_HIERARCHY.REQUEST',
      SUCCESS: 'ACCOUNTS_HIERARCHY.SUCCESS',
      FAILURE: 'ACCOUNTS_HIERARCHY.FAILURE',
    },
    UPDATE: {
      SEARCH_TERM: 'ACCOUNTS.UPDATE.SEARCH_TERM',
    },
    PAYMENT_TYPE: {
      REQUEST: 'ACCOUNTS.PAYMENT_TYPE.REQUEST',
      SUCCESS: 'ACCOUNTS.PAYMENT_TYPE.SUCCESS',
      FAILURE: 'ACCOUNTS.PAYMENT_TYPE.FAILURE',
      RESET: 'ACCOUNTS.PAYMENT_TYPE.RESET',
    },
    PAYMENT: {
      REQUEST: 'ACCOUNTS.PAYMENT.REQUEST',
      SUCCESS: 'ACCOUNTS.PAYMENT.SUCCESS',
      FAILURE: 'ACCOUNTS.PAYMENT.FAILURE',
      RESET: 'ACCOUNTS.PAYMENT.RESET',
    },
    INVOICES: {
      REQUEST: 'ACCOUNTS.INVOICES.REQUEST',
      SUCCESS: 'ACCOUNTS.INVOICES.SUCCESS',
      FAILURE: 'ACCOUNTS.INVOICES.FAILURE',
      RESET: 'ACCOUNTS.INVOICES.RESET',
      DOWNLOAD_SINGLE_FILE: {
        REQUEST: 'ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.REQUEST',
        SUCCESS: 'ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.SUCCESS',
        FAILURE: 'ACCOUNTS.INVOICES.DOWNLOAD_SINGLE_FILE.FAILURE',
      },
    },
    GRANDPARENT_ACCOUNT_NAME: {
      REQUEST: 'ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.REQUEST',
      SUCCESS: 'ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.SUCCESS',
      FAILURE: 'ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.FAILURE',
      RESET: 'ACCOUNTS.GRANDPARENT_ACCOUNT_NAME.RESET',
    },
    CONTRACT_BALANCES: {
      REQUEST: 'ACCOUNTS.CONTRACT_BALANCES.REQUEST',
      SUCCESS: 'ACCOUNTS.CONTRACT_BALANCES.SUCCESS',
      FAILURE: 'ACCOUNTS.CONTRACT_BALANCES.FAILURE',
    },
    ACQUIRING_CONTRACT_ADDRESS: {
      REQUEST: 'ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.REQUEST',
      SUCCESS: 'ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.SUCCESS',
      FAILURE: 'ACCOUNTS.ACQUIRING_CONTRACT_ADDRESS.FAILURE',
    },
    GET_ACCOUNTS_FOR_USER: {
      REQUEST: 'ACCOUNTS.GET_ACCOUNTS_FOR_USER.REQUEST',
      SUCCESS: 'ACCOUNTS.GET_ACCOUNTS_FOR_USER.SUCCESS',
      FAILURE: 'ACCOUNTS.GET_ACCOUNTS_FOR_USER.FAILURE',
      RESET: 'ACCOUNTS.GET_ACCOUNTS_FOR_USER.RESET',
    },
    TRANSFER_CARD_TARGET_ACCOUNTS: {
      REQUEST: 'ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.REQUEST',
      SUCCESS: 'ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.SUCCESS',
      FAILURE: 'ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.FAILURE',
      RESET: 'ACCOUNTS.TRANSFER_CARD_TARGET_ACCOUNTS.RESET',
    },
  },

  CARDS: {
    REQUEST: 'CARDS.REQUEST',
    SUCCESS: 'CARDS.SUCCESS',
    FAILURE: 'CARDS.FAILURE',
    RESET: 'CARDS.RESET',
    UPDATE_CARD_MODAL_META: 'CARDS.UPDATE_CARD_MODAL_META',
    UPDATE_CARD_MODAL_FORM_VALUES: 'CARDS.UPDATE_CARD_MODAL_FORM_VALUES',
    UPDATE_SELECTED_CARD: 'CARDS.UPDATE_SELECTED_CARD',
    DISABLE_EXPIRY_DATE: 'CARDS.DISABLE_EXPIRY_DATE',
    DETAIL: {
      REQUEST: 'CARDS.DETAIL.REQUEST',
      SUCCESS: 'CARDS.DETAIL.SUCCESS',
      FAILURE: 'CARDS.DETAIL.FAILURE',
      RESET: 'CARDS.DETAIL.RESET',
    },
    DOWNLOAD: {
      REQUEST: 'CARDS.DOWNLOAD.REQUEST',
      SUCCESS: 'CARDS.DOWNLOAD.SUCCESS',
      FAILURE: 'CARDS.DOWNLOAD.FAILURE',
    },
    UPDATE: {
      SEARCH_TERM: 'ACCOUNTS.UPDATE.SEARCH_TERM',
    },
    UPDATE_PIN: {
      REQUEST: 'CARDS.UPDATE_PIN.REQUEST',
      SUCCESS: 'CARDS.UPDATE_PIN.SUCCESS',
      FAILURE: 'CARDS.UPDATE_PIN.FAILURE',
      RESET: 'CARDS.UPDATE_PIN.RESET',
    },
    RESET_PIN: {
      RESET: 'CARDS.RESET_PIN.RESET',
      REQUEST: 'CARDS.RESET_PIN.REQUEST',
      SUCCESS: 'CARDS.RESET_PIN.SUCCESS',
      FAILURE: 'CARDS.RESET_PIN.FAILURE',
    },
    TRANSFER_SINGLE: {
      REQUEST: 'CARDS.TRANSFER_SINGLE.REQUEST',
      SUCCESS: 'CARDS.TRANSFER_SINGLE.SUCCESS',
      FAILURE: 'CARDS.TRANSFER_SINGLE.FAILURE',
      RESET: 'CARDS.TRANSFER_SINGLE.RESET',
    },
    TRANSFER_BATCH: {
      REQUEST: 'CARDS.TRANSFER_BATCH.REQUEST',
      SUCCESS: 'CARDS.TRANSFER_BATCH.SUCCESS',
      FAILURE: 'CARDS.TRANSFER_BATCH.FAILURE',
      RESET: 'CARDS.TRANSFER_BATCH.RESET',
    },
    ACTIVATE: {
      REQUEST: 'CARDS.ACTIVATE.REQUEST',
      SUCCESS: 'CARDS.ACTIVATE.SUCCESS',
      FAILURE: 'CARDS.ACTIVATE.FAILURE',
      RESET: 'CARDS.ACTIVATE.RESET',
    },
    ACTIVATE_MULTIPLE: {
      REQUEST: 'CARDS.ACTIVATE_MULTIPLE.REQUEST',
      SUCCESS: 'CARDS.ACTIVATE_MULTIPLE.SUCCESS',
      FAILURE: 'CARDS.ACTIVATE_MULTIPLE.FAILURE',
      RESET: 'CARDS.ACTIVATE_MULTIPLE.RESET',
    },
    STATUS: {
      REQUEST: 'CARDS.STATUS.REQUEST',
      SUCCESS: 'CARDS.STATUS.SUCCESS',
      FAILURE: 'CARDS.STATUS.FAILURE',
      RESET: 'CARDS.STATUS.RESET',
    },
    MULTIPLE_CARDS_STATUS: {
      REQUEST: 'CARDS.MULTIPLE_CARDS_STATUS.REQUEST',
      SUCCESS: 'CARDS.MULTIPLE_CARDS_STATUS.SUCCESS',
      FAILURE: 'CARDS.MULTIPLE_CARDS_STATUS.FAILURE',
      RESET: 'CARDS.MULTIPLE_CARDS_STATUS.RESET',
    },
    PENDING: {
      RESET: 'CARDS.PENDING.RESET',
      REQUEST: 'CARDS.PENDING.REQUEST',
      SUCCESS: 'CARDS.PENDING.SUCCESS',
      FAILURE: 'CARDS.PENDING.FAILURE',
    },
    CARD_OPTIONS: {
      REQUEST: 'CARDS.CARD_OPTIONS.REQUEST',
      SUCCESS: 'CARDS.CARD_OPTIONS.SUCCESS',
      FAILURE: 'CARDS.CARD_OPTIONS.FAILURE',
      RESET: 'CARDS.CARD_OPTIONS.RESET',
    },
    CREATE: {
      REQUEST: 'CARDS.CREATE.REQUEST',
      SUCCESS: 'CARDS.CREATE.SUCCESS',
      FAILURE: 'CARDS.CREATE.FAILURE',
      RESET: 'CARDS.CREATE.RESET',
      SHOW_MODAL: 'CARDS.CREATE.SHOW_MODAL',
      HIDE_MODAL: 'CARDS.CREATE.HIDE_MODAL',
      RESET_ADD_CARD: 'CARDS.CREATE.RESET_ADD_CARD',
    },
    EDIT: {
      REQUEST: 'CARDS.EDIT.REQUEST',
      SUCCESS: 'CARDS.EDIT.SUCCESS',
      FAILURE: 'CARDS.EDIT.FAILURE',
      RESET: 'CARDS.EDIT.RESET',
    },
    UPDATE_MULTIPLE: {
      REQUEST: 'CARDS.UPDATE_MULTIPLE.REQUEST',
      SUCCESS: 'CARDS.UPDATE_MULTIPLE.SUCCESS',
      FAILURE: 'CARDS.UPDATE_MULTIPLE.FAILURE',
      RESET: 'CARDS.UPDATE_MULTIPLE.RESET',
    },
    ACCOUNT_DEFAULT: {
      REQUEST: 'CARDS.ACCOUNT_DEFAULT.REQUEST',
      SUCCESS: 'CARDS.ACCOUNT_DEFAULT.SUCCESS',
      FAILURE: 'CARDS.ACCOUNT_DEFAULT.FAILURE',
    },
    ACCOUNT_DEFAULT_RESET: {
      REQUEST: 'CARDS.ACCOUNT_DEFAULT_RESET.REQUEST',
    },
    CANCEL_PENDING_TRANSFER_BATCH: {
      REQUEST: 'CARDS.CANCEL_PENDING_TRANSFER_BATCH.REQUEST',
      SUCCESS: 'CARDS.CANCEL_PENDING_TRANSFER_BATCH.SUCCESS',
      FAILURE: 'CARDS.CANCEL_PENDING_TRANSFER_BATCH.FAILURE',
    },
    UPDATE_PENDING_TRANSFER_BATCH: {
      REQUEST: 'CARDS.UPDATE_PENDING_TRANSFER_BATCH.REQUEST',
      SUCCESS: 'CARDS.UPDATE_PENDING_TRANSFER_BATCH.SUCCESS',
      FAILURE: 'CARDS.UPDATE_PENDING_TRANSFER_BATCH.FAILURE',
    },
    PENDING_TRANSFERS_DOWNLOAD: {
      REQUEST: 'CARDS.PENDING_TRANSFERS_DOWNLOAD.REQUEST',
      SUCCESS: 'CARDS.PENDING_TRANSFERS_DOWNLOAD.SUCCESS',
      FAILURE: 'CARDS.PENDING_TRANSFERS_DOWNLOAD.FAILURE',
    },
    GLOBAL_SEARCH: {
      REQUEST: 'CARDS.GLOBAL_SEARCH.REQUEST',
      SUCCESS: 'CARDS.GLOBAL_SEARCH.SUCCESS',
      FAILURE: 'CARDS.GLOBAL_SEARCH.FAILURE',
      RESET: 'CARDS.GLOBAL_SEARCH_RESET',
    },
  },
  ADDRESSES: {
    REQUEST: 'ADDRESSES.REQUEST',
    SUCCESS: 'ADDRESSES.SUCCESS',
    FAILURE: 'ADDRESSES.FAILURE',
    UPDATE: {
      REQUEST: 'ADDRESSES.UPDATE.REQUEST',
      SUCCESS: 'ADDRESSES.UPDATE.SUCCESS',
      FAILURE: 'ADDRESSES.UPDATE.FAILURE',
      RESET: 'ADDRESSES.UPDATE.RESET',
    },
  },
  TRANSACTIONITEMS: {
    REQUEST: 'TRANSACTIONITEMS.REQUEST',
    SUCCESS: 'TRANSACTIONITEMS.SUCCESS',
    FAILURE: 'TRANSACTIONITEMS.FAILURE',
  },
  TRANSACTIONS: {
    REQUEST: 'TRANSACTIONS.REQUEST',
    SUCCESS: 'TRANSACTIONS.SUCCESS',
    FAILURE: 'TRANSACTIONS.FAILURE',
    RESET: 'TRANSACTIONS.RESET',
    FILTER: {
      REQUEST: 'TRANSACTIONS.FILTER.REQUEST',
      SUCCESS: 'TRANSACTIONS.FILTER.SUCCESS',
      FAILURE: 'TRANSACTIONS.FILTER.FAILURE',
    },
    DOWNLOAD: {
      REQUEST: 'TRANSACTIONS.DOWNLOAD.REQUEST',
      SUCCESS: 'TRANSACTIONS.DOWNLOAD.SUCCESS',
      FAILURE: 'TRANSACTIONS.DOWNLOAD.FAILURE',
    },
  },
  BILLING: {
    REQUEST: 'BILLING.REQUEST',
    SUCCESS: 'BILLING.SUCCESS',
    FAILURE: 'BILLING.FAILURE',
    RESET: 'BILLING.RESET',
  },
  USERS: {
    LOGIN_USER: {
      REQUEST: 'LOGIN_USER.REQUEST',
      SUCCESS: 'LOGIN_USER.SUCCESS',
      FAILURE: 'LOGIN_USER.FAILURE',
    },
    ME: {
      REQUEST: 'GET_USER.REQUEST',
      SUCCESS: 'GET_USER.SUCCESS',
      FAILURE: 'GET_USER.FAILURE',
    },
    DETAILED_FETCH: {
      REQUEST: 'DETAILED_FETCH.REQUEST',
      SUCCESS: 'DETAILED_FETCH.SUCCESS',
      FAILURE: 'DETAILED_FETCH.FAILURE',
      RESET: 'DETAILED_FETCH.RESET',
    },
    ADMIN_DETAILED_FETCH: {
      REQUEST: 'ADMIN_DETAILED_FETCH.REQUEST',
      SUCCESS: 'ADMIN_DETAILED_FETCH.SUCCESS',
      FAILURE: 'ADMIN_DETAILED_FETCH.FAILURE',
      RESET: 'ADMIN_DETAILED_FETCH.RESET',
    },
    SEARCH_USER_EXISTS: {
      REQUEST: 'USERS.SEARCH_USER_EXISTS.REQUEST',
      SUCCESS: 'USERS.SEARCH_USER_EXISTS.SUCCESS',
      FAILURE: 'USERS.SEARCH_USER_EXISTS.FAILURE',
      RESET: 'USERS.SEARCH_USER_EXISTS.RESET',
    },
    ADMIN_SEARCH_USER_EXISTS: {
      REQUEST: 'USERS.ADMIN_SEARCH_USER_EXISTS.REQUEST',
      SUCCESS: 'USERS.ADMIN_SEARCH_USER_EXISTS.SUCCESS',
      FAILURE: 'USERS.ADMIN_SEARCH_USER_EXISTS.FAILURE',
      RESET: 'USERS.ADMIN_SEARCH_USER_EXISTS.RESET',
    },
    FETCH: {
      REQUEST: 'USERS.REQUEST',
      USER_REQUEST: 'USERS.USER_REQUEST',
      SUCCESS: 'USERS.SUCCESS',
      FAILURE: 'USERS.FAILURE',
      RESET: 'USERS.RESET',
    },
    CREATE: {
      REQUEST: 'CREATE_USER.REQUEST',
      SUCCESS: 'CREATE_USER.SUCCESS',
      FAILURE: 'CREATE_USER.FAILURE',
      RESET: 'CREATE_USER.RESET',
    },
    UPDATE: {
      REQUEST: 'UPDATE_USER.REQUEST',
      SUCCESS: 'UPDATE_USER.SUCCESS',
      FAILURE: 'UPDATE_USER.FAILURE',
      RESET: 'UPDATE_USER.RESET',
    },
    ADMIN_UPDATE_USER: {
      REQUEST: 'ADMIN_UPDATE_USER.REQUEST',
      SUCCESS: 'ADMIN_UPDATE_USER.SUCCESS',
      FAILURE: 'ADMIN_UPDATE_USER.FAILURE',
      RESET: 'ADMIN_UPDATE_USER.RESET',
    },
    UPDATE_USER_SELF: {
      REQUEST: 'UPDATE_USER_SELF.REQUEST',
      SUCCESS: 'UPDATE_USER_SELF.SUCCESS',
      FAILURE: 'UPDATE_USER_SELF.FAILURE',
      RESET: 'UPDATE_USER_SELF.RESET',
    },
    DELETE: {
      REQUEST: 'DELETE_USER.REQUEST',
      SUCCESS: 'DELETE_USER.SUCCESS',
      FAILURE: 'DELETE_USER.FAILURE',
      RESET: 'DELETE_USER.RESET',
    },
    ADMIN_DELETE_USER: {
      REQUEST: 'ADMIN_DELETE_USER.REQUEST',
      SUCCESS: 'ADMIN_DELETE_USER.SUCCESS',
      FAILURE: 'ADMIN_DELETE_USER.FAILURE',
      RESET: 'ADMIN_DELETE_USER.RESET',
    },
    ASSIGN_ACCOUNTS: {
      REQUEST: 'ASSIGN_ACCOUNTS.REQUEST',
      SUCCESS: 'ASSIGN_ACCOUNTS.SUCCESS',
      FAILURE: 'ASSIGN_ACCOUNTS.FAILURE',
      RESET: 'ASSIGN_ACCOUNTS.RESET',
    },
    UPDATE_ASSIGN_ACCOUNTS_REQUEST: 'UPDATE_ASSIGN_ACCOUNTS_REQUEST',
    EMAIL_LOOKUP: {
      REQUEST: 'EMAIL_LOOKUP.REQUEST',
      SUCCESS: 'EMAIL_LOOKUP.SUCCESS',
      FAILURE: 'EMAIL_LOOKUP.FAILURE',
      RESET: 'EMAIL_LOOKUP.RESET',
    },
    DOWNLOAD: {
      REQUEST: 'USERS.DOWNLOAD.REQUEST',
      SUCCESS: 'USERS.DOWNLOAD.SUCCESS',
      FAILURE: 'USERS.DOWNLOAD.FAILURE',
    },
    DOWNLOAD_ALL_USERS: {
      REQUEST: 'USERS.DOWNLOAD_ALL_USERS.REQUEST',
      SUCCESS: 'USERS.DOWNLOAD_ALL_USERS.SUCCESS',
      FAILURE: 'USERS.DOWNLOAD_ALL_USERS.FAILURE',
    },
    SEARCH_ALL_USERS: {
      REQUEST: 'USERS.SEARCH_ALL_USERS.REQUEST',
      SUCCESS: 'USERS.SEARCH_ALL_USERS.SUCCESS',
      FAILURE: 'USERS.SEARCH_ALL_USERS.FAILURE',
      RESET: 'USERS.SEARCH_ALL_USERS.RESET',
    },
    SEARCH_ALL_IMPERSONATE_USERS: {
      REQUEST: 'USERS.SEARCH_ALL_IMPERSONATE_USERS.REQUEST',
      SUCCESS: 'USERS.SEARCH_ALL_IMPERSONATE_USERS.SUCCESS',
      FAILURE: 'USERS.SEARCH_ALL_IMPERSONATE_USERS.FAILURE',
      RESET: 'USERS.SEARCH_ALL_IMPERSONATE_USERS.RESET',
    },
    IMPERSONATE_USER: {
      REQUEST: 'USERS.IMPERSONATE_USER.REQUEST',
      SUCCESS: 'USERS.IMPERSONATE_USER.SUCCESS',
      FAILURE: 'USERS.IMPERSONATE_USER.FAILURE',
    },
    SET_ASSIGNED_GRANDFATHER_DETAILS: 'USERS.SET_ASSIGNED_GRANDFATHER_DETAILS',
    SET_CAN_READ_WRITE: 'USERS.SET_CAN_READ_WRITE',
    SET_USER_AS_ADMIN: 'USERS.SET_USER_AS_ADMIN',
    SET_USER_AS_UNAUTHORISED: 'USERS.SET_USER_AS_UNAUTHORISED',
    SET_PORTAL_TYPE: 'USERS.SET_PORTAL_TYPE',
    ADMIN_GET_ASSIGNED_ACCOUNTS: {
      REQUEST: 'USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.REQUEST',
      SUCCESS: 'USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.SUCCESS',
      FAILURE: 'USERS.ADMIN_GET_ASSIGNED_ACCOUNTS.FAILURE',
    },
    ADMIN_REMOVE_ACCOUNT_ACCESS: {
      REQUEST: 'USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.REQUEST',
      SUCCESS: 'USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.SUCCESS',
      FAILURE: 'USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.FAILURE',
      RESET: 'USERS.ADMIN_REMOVE_ACCOUNT_ACCESS.RESET',
    },
    LOGOUT: {
      REQUEST: 'USERS.LOGOUT.REQUEST',
      SUCCESS: 'USERS.LOGOUT.SUCCESS',
      FAILURE: 'USERS.LOGOUT.FAILURE',
    },
  },
  ROLES: {
    FETCH: {
      REQUEST: 'ROLES.REQUEST',
      SUCCESS: 'ROLES.SUCCESS',
      FAILURE: 'ROLES.FAILURE',
    },
    ASSIGN_ROLES: {
      REQUEST: 'ASSIGN_ROLES.REQUEST',
      SUCCESS: 'ASSIGN_ROLES.SUCCESS',
      FAILURE: 'ASSIGN_ROLES.FAILURE',
      RESET: 'ASSIGN_ROLES.RESET',
    },
  },
  NOTIFICATIONS: {
    FETCH: {
      REQUEST: 'NOTIFICATIONS.REQUEST',
      SUCCESS: 'NOTIFICATIONS.SUCCESS',
      FAILURE: 'NOTIFICATIONS.FAILURE',
    },
    MARK_AS_READ: {
      REQUEST: 'NOTIFICATIONS.MARK_AS_READ.REQUEST',
      SUCCESS: 'NOTIFICATIONS.MARK_AS_READ.SUCCESS',
      FAILURE: 'NOTIFICATIONS.MARK_AS_READ.FAILURE',
    },
  },
  STORE: {
    GET_CARD_OPTIONS: {
      REQUEST: 'STORE.GET_CARD_OPTIONS.REQUEST',
      SUCCESS: 'STORE.GET_CARD_OPTIONS.SUCCESS',
      FAILURE: 'STORE.GET_CARD_OPTIONS.FAILURE',
      RESET: 'STORE.GET_CARD_OPTIONS.RESET',
    },
    GET_VEHICLE_TYPES: {
      REQUEST: 'STORE.GET_VEHICLE_TYPES.REQUEST',
      SUCCESS: 'STORE.GET_VEHICLE_TYPES.SUCCESS',
      FAILURE: 'STORE.GET_VEHICLE_TYPES.FAILURE',
    },
    CREATE_CARD_OPTIONS: {
      REQUEST: 'STORE.CREATE_CARD_OPTIONS.REQUEST',
      SUCCESS: 'STORE.CREATE_CARD_OPTIONS.SUCCESS',
      FAILURE: 'STORE.CREATE_CARD_OPTIONS.FAILURE',
    },
    UPDATE_CARD_OPTIONS: {
      REQUEST: 'STORE.UPDATE_CARD_OPTIONS.REQUEST',
      SUCCESS: 'STORE.UPDATE_CARD_OPTIONS.SUCCESS',
      FAILURE: 'STORE.UPDATE_CARD_OPTIONS.FAILURE',
    },
    GET_REPORT_TYPES: {
      REQUEST: 'STORE.GET_REPORT_TYPES.REQUEST',
      SUCCESS: 'STORE.GET_REPORT_TYPES.SUCCESS',
      FAILURE: 'STORE.GET_REPORT_TYPES.FAILURE',
    },
  },
  REPORTS: {
    GET_SCHEDULED_REPORTS_LIST: {
      REQUEST: 'REPORTS.GET_SCHEDULED_REPORTS_LIST.REQUEST',
      SUCCESS: 'REPORTS.GET_SCHEDULED_REPORTS_LIST.SUCCESS',
      FAILURE: 'REPORTS.GET_SCHEDULED_REPORTS_LIST.FAILURE',
      RESET: 'REPORTS.GET_SCHEDULED_REPORTS_LIST.RESET',
    },
    GET_SCHEDULED_REPORT: {
      REQUEST: 'REPORTS.GET_SCHEDULED_REPORT.REQUEST',
      SUCCESS: 'REPORTS.GET_SCHEDULED_REPORT.SUCCESS',
      FAILURE: 'REPORTS.GET_SCHEDULED_REPORT.FAILURE',
    },
    CREATE_SCHEDULED_REPORT: {
      REQUEST: 'REPORTS.CREATE_SCHEDULED_REPORT.REQUEST',
      SUCCESS: 'REPORTS.CREATE_SCHEDULED_REPORT.SUCCESS',
      FAILURE: 'REPORTS.CREATE_SCHEDULED_REPORT.FAILURE',
      RESET: 'REPORTS.CREATE_SCHEDULED_REPORT.RESET',
    },
    UPDATE_SCHEDULED_REPORT: {
      REQUEST: 'REPORTS.UPDATE_SCHEDULED_REPORT.REQUEST',
      SUCCESS: 'REPORTS.UPDATE_SCHEDULED_REPORT.SUCCESS',
      FAILURE: 'REPORTS.UPDATE_SCHEDULED_REPORT.FAILURE',
      RESET: 'REPORTS.UPDATE_SCHEDULED_REPORT.RESET',
    },
    DELETE_SCHEDULED_REPORT: {
      REQUEST: 'REPORTS.DELETE_SCHEDULED_REPORT.REQUEST',
      SUCCESS: 'REPORTS.DELETE_SCHEDULED_REPORT.SUCCESS',
      FAILURE: 'REPORTS.DELETE_SCHEDULED_REPORT.FAILURE',
      RESET: 'REPORTS.DELETE_SCHEDULED_REPORT.RESET',
    },
    ENABLE_SCHEDULED_REPORT: {
      REQUEST: 'REPORTS.ENABLE_SCHEDULED_REPORT.REQUEST',
      SUCCESS: 'REPORTS.ENABLE_SCHEDULED_REPORT.SUCCESS',
      FAILURE: 'REPORTS.ENABLE_SCHEDULED_REPORT.FAILURE',
      RESET: 'REPORTS.ENABLE_SCHEDULED_REPORT.RESET',
    },
    DISABLE_SCHEDULED_REPORT: {
      REQUEST: 'REPORTS.DISABLE_SCHEDULED_REPORT.REQUEST',
      SUCCESS: 'REPORTS.DISABLE_SCHEDULED_REPORT.SUCCESS',
      FAILURE: 'REPORTS.DISABLE_SCHEDULED_REPORT.FAILURE',
      RESET: 'REPORTS.DISABLE_SCHEDULED_REPORT.RESET',
    },
    GET_REPORTS_LIST: {
      REQUEST: 'REPORTS.GET_REPORTS_LIST.REQUEST',
      RESET: 'REPORTS.GET_REPORTS_LIST.RESET',
      SUCCESS: 'REPORTS.GET_REPORTS_LIST.SUCCESS',
      FAILURE: 'REPORTS.GET_REPORTS_LIST.FAILURE',
    },
    DOWNLOAD_REPORT: {
      REQUEST: 'REPORTS.DOWNLOAD_REPORT.REQUEST',
      SUCCESS: 'REPORTS.DOWNLOAD_REPORT.SUCCESS',
      FAILURE: 'REPORTS.DOWNLOAD_REPORT.FAILURE',
    },
  },
  MAINTENANCE: {
    PLASTIC_TYPES_LIST: {
      REQUEST: 'MAINTENANCE.PLASTIC_TYPES_LIST.REQUEST',
      SUCCESS: 'MAINTENANCE.PLASTIC_TYPES_LIST.SUCCESS',
      FAILURE: 'MAINTENANCE.PLASTIC_TYPES_LIST.FAILURE',
    },
    PLASTIC_TYPE: {
      REQUEST: 'MAINTENANCE.PLASTIC_TYPE.REQUEST',
      SUCCESS: 'MAINTENANCE.PLASTIC_TYPE.SUCCESS',
      FAILURE: 'MAINTENANCE.PLASTIC_TYPE.FAILURE',
    },
    PLASTIC_TYPE_RESET: {
      REQUEST: 'MAINTENANCE.PLASTIC_TYPE_RESET.REQUEST',
    },
    CREATE_PLASTIC_TYPE: {
      REQUEST: 'MAINTENANCE.CREATE_PLASTIC_TYPE.REQUEST',
      SUCCESS: 'MAINTENANCE.CREATE_PLASTIC_TYPE.SUCCESS',
      FAILURE: 'MAINTENANCE.CREATE_PLASTIC_TYPE.FAILURE',
      RESET: 'MAINTENANCE.CREATE_PLASTIC_TYPE.RESET',
    },
    UPDATE_PLASTIC_TYPE: {
      REQUEST: 'MAINTENANCE.UPDATE_PLASTIC_TYPE.REQUEST',
      SUCCESS: 'MAINTENANCE.UPDATE_PLASTIC_TYPE.SUCCESS',
      FAILURE: 'MAINTENANCE.UPDATE_PLASTIC_TYPE.FAILURE',
      RESET: 'MAINTENANCE.UPDATE_PLASTIC_TYPE.RESET',
    },
    GET_SCHEDULE: {
      REQUEST: 'MAINTENANCE.GET_SCHEDULE.REQUEST',
      SUCCESS: 'MAINTENANCE.GET_SCHEDULE.SUCCESS',
      FAILURE: 'MAINTENANCE.GET_SCHEDULE.FAILURE',
    },
    GET_SCHEDULES_LIST: {
      REQUEST: 'MAINTENANCE.GET_SCHEDULES_LIST.REQUEST',
      SUCCESS: 'MAINTENANCE.GET_SCHEDULES_LIST.SUCCESS',
      FAILURE: 'MAINTENANCE.GET_SCHEDULES_LIST.FAILURE',
    },
    CREATE_SCHEDULE: {
      REQUEST: 'MAINTENANCE.CREATE_SCHEDULE.REQUEST',
      SUCCESS: 'MAINTENANCE.CREATE_SCHEDULE.SUCCESS',
      FAILURE: 'MAINTENANCE.CREATE_SCHEDULE.FAILURE',
      RESET: 'MAINTENANCE.CREATE_SCHEDULE.RESET',
    },
    UPDATE_SCHEDULE: {
      REQUEST: 'MAINTENANCE.UPDATE_SCHEDULE.REQUEST',
      SUCCESS: 'MAINTENANCE.UPDATE_SCHEDULE.SUCCESS',
      FAILURE: 'MAINTENANCE.UPDATE_SCHEDULE.FAILURE',
      RESET: 'MAINTENANCE.UPDATE_SCHEDULE.RESET',
    },
    DELETE_SCHEDULE: {
      REQUEST: 'MAINTENANCE.DELETE_SCHEDULE.REQUEST',
      SUCCESS: 'MAINTENANCE.DELETE_SCHEDULE.SUCCESS',
      FAILURE: 'MAINTENANCE.DELETE_SCHEDULE.FAILURE',
      RESET: 'MAINTENANCE.DELETE_SCHEDULE.RESET',
    },
  },
  ACCOUNTING_INTEGRATION: {
    ENROLMENT_STATUS: {
      REQUEST: 'ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.REQUEST',
      SUCCESS: 'ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.SUCCESS',
      FAILURE: 'ACCOUNTING_INTEGRATION.ENROLMENT_STATUS.FAILURE',
    },
    MYOB_LOGIN_URI: {
      REQUEST: 'ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.REQUEST',
      SUCCESS: 'ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.SUCCESS',
      FAILURE: 'ACCOUNTING_INTEGRATION.MYOB_LOGIN_URI.FAILURE',
    },
    MYOB_DISCONNECT: {
      REQUEST: 'ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.REQUEST',
      SUCCESS: 'ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.SUCCESS',
      FAILURE: 'ACCOUNTING_INTEGRATION.MYOB_DISCONNECT.FAILURE',
    },
    XERO_LOGIN_URI: {
      REQUEST: 'ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.REQUEST',
      SUCCESS: 'ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.SUCCESS',
      FAILURE: 'ACCOUNTING_INTEGRATION.XERO_LOGIN_URI.FAILURE',
    },
    XERO_CONNECT: {
      REQUEST: 'ACCOUNTING_INTEGRATION.XERO_CONNECT.REQUEST',
      SUCCESS: 'ACCOUNTING_INTEGRATION.XERO_CONNECT.SUCCESS',
      FAILURE: 'ACCOUNTING_INTEGRATION.XERO_CONNECT.FAILURE',
    },
    XERO_DISCONNECT: {
      REQUEST: 'ACCOUNTING_INTEGRATION.XERO_DISCONNECT.REQUEST',
      SUCCESS: 'ACCOUNTING_INTEGRATION.XERO_DISCONNECT.SUCCESS',
      FAILURE: 'ACCOUNTING_INTEGRATION.XERO_DISCONNECT.FAILURE',
    },
  },
  EVERYDAY_REWARDS: {
    ENROLMENT_STATUS: {
      REQUEST: 'EVERYDAY_REWARDS.ENROLMENT_STATUS.REQUEST',
      SUCCESS: 'EVERYDAY_REWARDS.ENROLMENT_STATUS.SUCCESS',
      FAILURE: 'EVERYDAY_REWARDS.ENROLMENT_STATUS.FAILURE',
    },
    LOGIN_URI: {
      REQUEST: 'EVERYDAY_REWARDS.LOGIN_URI.REQUEST',
      SUCCESS: 'EVERYDAY_REWARDS.LOGIN_URI.SUCCESS',
      FAILURE: 'EVERYDAY_REWARDS.LOGIN_URI.FAILURE',
    },
    CONNECT: {
      REQUEST: 'EVERYDAY_REWARDS.CONNECT.REQUEST',
      SUCCESS: 'EVERYDAY_REWARDS.CONNECT.SUCCESS',
      FAILURE: 'EVERYDAY_REWARDS.CONNECT.FAILURE',
    },
    DISCONNECT: {
      REQUEST: 'EVERYDAY_REWARDS.DISCONNECT.REQUEST',
      SUCCESS: 'EVERYDAY_REWARDS.DISCONNECT.SUCCESS',
      FAILURE: 'EVERYDAY_REWARDS.DISCONNECT.FAILURE',
    },
  },
  CASH: {
    ORDERS_LIST: {
      REQUEST: 'CASH.ORDERS_LIST.REQUEST',
      SUCCESS: 'CASH.ORDERS_LIST.SUCCESS',
      FAILURE: 'CASH.ORDERS_LIST.FAILURE',
      RESET: 'CASH.ORDERS_LIST.RESET',
    },
    ORDER_DETAILS: {
      REQUEST: 'CASH.ORDER_DETAILS.REQUEST',
      SUCCESS: 'CASH.ORDER_DETAILS.SUCCESS',
      FAILURE: 'CASH.ORDER_DETAILS.FAILURE',
      RESET: 'CASH.ORDER_DETAILS.RESET',
    },
    CARD_DETAILS: {
      REQUEST: 'CASH.CARD_DETAILS.REQUEST',
      SUCCESS: 'CASH.CARD_DETAILS.SUCCESS',
      FAILURE: 'CASH.CARD_DETAILS.FAILURE',
      RESET: 'CASH.CARD_DETAILS.RESET',
    },
    ORDER_DEFAULTS: {
      REQUEST: 'CASH.ORDER_DEFAULTS.REQUEST',
      SUCCESS: 'CASH.ORDER_DEFAULTS.SUCCESS',
      FAILURE: 'CASH.ORDER_DEFAULTS.FAILURE',
    },
    CREATE_ORDER: {
      REQUEST: 'CASH.CREATE_ORDER.REQUEST',
      SUCCESS: 'CASH.CREATE_ORDER.SUCCESS',
      FAILURE: 'CASH.CREATE_ORDER.FAILURE',
    },
    ORDER_ACTIVATE_ALL_CARDS: {
      REQUEST: 'CASH.ORDER_ACTIVATE_ALL_CARDS.REQUEST',
      SUCCESS: 'CASH.ORDER_ACTIVATE_ALL_CARDS.SUCCESS',
      FAILURE: 'CASH.ORDER_ACTIVATE_ALL_CARDS.FAILURE',
      RESET: 'CASH.ORDER_ACTIVATE_ALL_CARDS.RESET',
    },
    ADD_CART_ITEM: 'CASH.ADD_CART_ITEM',
    DEL_CART_ITEM: 'CASH.DEL_CART_ITEM',
    EDIT_CART_ITEM: 'CASH.EDIT_CART_ITEM',
    EDIT_CART_MEDIA_TYPE: 'CASH.EDIT_CART_MEDIA_TYPE',
    RESET_ORDER: 'CASH.RESET_ORDER',
    SET_DELIVERY_OPTION: 'CASH.SET_DELIVERY_OPTION',
    SET_SINGLE_SHIPPING_ADDRESS: 'CASH.SET_SINGLE_SHIPPING_ADDRESS',
    SET_PHYSICAL_ADDRESS_RECIPIENT: 'CASH.SET_PHYSICAL_ADDRESS_RECIPIENT',
    REMOVE_PHYSICAL_ADDRESS_RECIPIENT: 'CASH.REMOVE_PHYSICAL_ADDRESS_RECIPIENT',
    SET_CART_ITEM_RECIPIENT: 'CASH.SET_CART_ITEM_RECIPIENT',
    REMOVE_CART_ITEM_RECIPIENT: 'CASH.REMOVE_CART_ITEM_RECIPIENT',
    SET_SHIPPING_METHOD: 'CASH.SET_SHIPPING_METHOD',
    SET_ORDER_DISCOUNT: 'CASH.SET_ORDER_DISCOUNT',
    SET_ADDITIONAL_INFORMATION: 'CASH.SET_ADDITIONAL_INFORMATION',
    SET_SHIPPING_WAIVED: 'CASH.SET_SHIPPING_WAIVED',
    SET_ORDER_CARD_DETAILS_PAGE_NUMBER: 'CASH.SET_ORDER_CARD_DETAILS_PAGE_NUMBER',
    SET_MODAL_STEP: 'CASH.SET_MODAL_STEP',
  },
  MODAL: {
    SET_ALL_BUTTONS: 'MODAL.SET_ALL_BUTTONS',
    SET_PRIMARY_BUTTON: 'MODAL.SET_PRIMARY_BUTTON',
    SET_SECONDARY_BUTTON: 'MODAL.SET_SECONDARY_BUTTON',
    RESET_BUTTONS: 'MODAL.RESET_BUTTONS',
  },
  TOAST_ALERT: {
    ADD: 'TOAST_ALERT.ADD',
    ADD_MODAL: 'TOAST_ALERT.ADD_MODAL',
    RESET: 'TOAST_ALERT.RESET',
    RESET_MODAL: 'TOAST_ALERT.RESET_MODAL',
  },
};
